import { Heading } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

import useStyles from '../styles'
import { Settings } from '../types'
import UserlevelSelector from './UserlevelSelector'

interface UserlevelSelectProps {
  settings?: Settings
  updateSettings?: (settings: Partial<Settings>) => void
  isLoading: boolean
}

const UserlevelSelect = ({
  settings,
  updateSettings,
  isLoading,
}: UserlevelSelectProps) => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <>
      <Heading headingLevel="1" headingLevelStyle="3">
        {t('User level')}
      </Heading>

      <div className={classes.select}>
        <UserlevelSelector
          settings={settings}
          updateSettings={updateSettings}
          isLoading={isLoading}
        />
      </div>
    </>
  )
}

export default UserlevelSelect
